module.exports = __webpack_public_path__ + "9f05e67bc16f5c14ff6827f5c147305e.MP3";